import React from 'react';
import styled from 'styled-components';
import { FontFamily } from '@zocdoc/components/src/typography';
import { breakpoint, HideFor } from '@zocdoc/components/src/grid';
import { FormattedMessage } from 'react-intl';

export const BookingSubSection = ({
    children,
    hideLabelOnMobile,
    label,
    labelValues,
}) => {
    return (
        <Wrapper>
            <Label hideLabelOnMobile={hideLabelOnMobile}>
                <FormattedMessage
                    {...label}
                    values={labelValues}
                />
            </Label>
            { children }
        </Wrapper>
    );
};

export const BookingSubSectionWithNoLabelOnMobile = ({ children, label }) => {
    return (
        <Wrapper>
            <HideFor
                small
                xsmall
                xxsmall
            >
                <Label>
                    <FormattedMessage {...label} />
                </Label>
            </HideFor>
            { children }
        </Wrapper>
    );
};

export const BookingSubSection1Z = ({
    children,
    hideLabelOnMobile,
    inline,
    marginTop = 25,
    label,
    labelValues,
}) => {
    const SubSectionWrapper = inline ? InlineWrapper : Wrapper;
    const StyledLabel = inline ? InlineLabel : Label1Z;
    return (
        <SubSectionWrapper marginTop={marginTop}>
            {label && (
                <HideFor
                    small={hideLabelOnMobile}
                    xsmall={hideLabelOnMobile}
                    xxsmall={hideLabelOnMobile}
                >
                    <StyledLabel>
                        <FormattedMessage
                            {...label}
                            values={labelValues}
                        />
                    </StyledLabel>
                </HideFor>
            )}
            { children }
        </SubSectionWrapper>
    );
};


export const InlineWrapper = styled.div`
    font: 13px/1 ${FontFamily.SharpSansSemibold};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    margin-bottom: -8px;
`;

export const Wrapper = styled.div`
    font: 15px/1 ${FontFamily.SharpSansSemibold};
    color: ${p => p.theme.profile.textColor};

    ${breakpoint.medium} {
        margin-top: ${p => p.marginTop}px;
    }
`;

export const InlineLabel = styled.div`
    letter-spacing 0.1px;
    margin-right: 11px;
`;

export const Label = styled.div`
    font: 15px/1 ${FontFamily.SharpSansBold};
    letter-spacing: 0.1px;
    margin-top: 22px;
    margin-bottom: 8px;
    ${p => p.hideLabelOnMobile && 'display: none;'}

    ${breakpoint.medium} {
        ${p => p.hideLabelOnMobile && 'display: block;'}
        font-size: 18px;
        margin-bottom: 11px;
    }
`;

export const Label1Z = styled.div`
    font: 15px/1 ${FontFamily.SharpSansSemiBold};
    letter-spacing: 0.1px;
    margin-top: 13px;
    margin-bottom: 8px;
`;
